import {
  Paper,
  Typography,
} from "@mui/material";

// ----------------------------------------------------------------------

export default function NoTrackingRecord() {
  return (
    <Paper
      sx={{ alignItems: 'center', textAlign: 'center', py: 6 }}
    >
      <Typography variant="h6" paragraph>
        아직 기록된 근무가 없어요.
      </Typography>
      <Typography variant="body2" color="text.disabled">
        크루가 출근, 퇴근 하면 알려드릴게요!
      </Typography>
    </Paper>
  )
}